module.exports = __webpack_public_path__ + "static/media/facebook.ae8f2ba1.png";